module.exports = __webpack_public_path__ + "static/media/jobskills_bakgrundsbild_mobil_ar.f7d8c2b5.jpg";